export { ConfluenceTrialSpotlight } from '../src/ConfluenceTrialSpotlight.tsx';
